<div class="voicerecorder">
  <!-- @if (uploading()) {
  <div class="w-100 mb-3">
    <div class="progress w-100 mt-3">
      <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
        [style.width.%]="uploadProgress()">
        {{ uploadProgress() }}%
      </div>
    </div>
  </div>
  } -->

  <div class="position-relative">
    @if (showPreview()) {
      <span
        class="position-absolute bg-gray-100 mt-n2 me-n1 rounded-3 p-1 top-0 end-0 d-flex align-items-center bg-white border-success border rounded-circle justify-content-center wh-24 text-success"
        role="button"
        [ngbPopover]="showRecording"
        [placement]="'top-end'"
        [autoClose]="'outside'"
      >
        <i class="bi bi-eye"></i>
      </span>
    }
    <div
      class="px-3 btn d-flex align-items-center justify-content-center wh-48 rounded-circle text-white shadow voicerecorder-outer gap-2 z-3"
      role="button"
      [ngbTooltip]="'Record Voice'"
      (click)="togglePanel()"
      [ngClass]="showPreview() ? 'btn-success' : 'btn-danger'"
    >
      <span class="voicerecorder-inner d-flex gap-2 align-items-center justify-content-center">
        <i class="bi bi-mic fs-18"></i>
      </span>
    </div>
  </div>

  <div
    class="rounded-2 shadow-lg bg-white z-3 position-fixed voicerecorderarea"
    [ngClass]="isPanelOpen() ? 'isShow' : ''"
  >
    <div class="shadow-sm p-4">
      <div class="d-flex align-items-center mb-3">
        <h3 class="fw-600 fs-24 mb-0">Audio Recorder</h3>
        <svg-icon [name]="'modal-close-menu'" class="svg-32 ms-auto" role="button" (click)="togglePanel()"></svg-icon>
      </div>

      <div class="bg-light p-4 text-center rounded-4">
        <h3 class="fw-600 fs-32">{{ formattedTime() }}</h3>
        @if (status() === 'paused') {
          <span class="mb-2 d-block"><i class="bi bi-pause"></i> Paused</span>
        }
        @if (status() === 'recording') {
          <span class="mb-2 d-block"><span class="recording-dot me-2"></span> Recording...</span>
        }
        @if (status() === 'idle') {
          <span class="mb-2 d-block">Ready to record</span>
        }
        @if (status() === 'finished' && showPreview()) {
          <span class="mb-2 d-block">Recording has ended</span>
        }
        <small class="text-muted d-block mb-3">Max duration {{ allowedDurationLabel() }}</small>

        @if (status() === 'idle' || status() === 'finished') {
          <div class="d-flex align-items-center justify-content-center gap-3">
            <button type="button" class="btn btn-danger btn-h42" (click)="startRecording()" [disabled]="uploading()">
              <i class="bi bi-mic me-1 fs-14"></i>Start
            </button>
            @if (showPreview()) {
              <button
                type="button"
                class="btn btn-primary btn-h42"
                (click)="uploadRecording()"
                [disabled]="uploading()"
              >
                <i class="bi bi-check-circle me-1 fs-14"></i>Done
              </button>
            }
          </div>
        }
        @if (status() === 'recording' || status() === 'paused') {
          <div class="d-flex align-items-center justify-content-center gap-3 mt-3">
            <button type="button" class="btn btn-outline-secondary btn-h42" (click)="pauseOrResume()">
              @if (status() === 'paused') {
                <i class="bi bi-mic fs-14 lh-1"></i> Resume
              } @else {
                <i class="bi bi-pause-fill fs-14 lh-1"></i> Pause
              }
            </button>
            <button type="button" class="btn btn-secondary btn-h42" (click)="stopRecording()">
              <i class="bi bi-stop-fill fs-14 lh-1"></i>Stop
            </button>
          </div>
        }
      </div>
      @if (uploading()) {
        <div class="w-100 mb-3">
          <div class="progress w-100 mt-3">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              [style.width.%]="uploadProgress()"
            >
              {{ uploadProgress() }}%
            </div>
          </div>
        </div>
      }
      @if (alertMessage()) {
        <div class="alert alert-warning d-flex align-items-center justify-content-between gap-2 mb-3">
          <span>{{ alertMessage() }}</span>
          @if (canRetryPermission()) {
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="retryPermissionRequest()">
              Try again
            </button>
          }
        </div>
      }
    </div>
  </div>
</div>

<ng-template #showRecording>
  <div style="min-width: 25rem" class="p-1">
    <h3 class="mb-3">Voice Recording</h3>
    <div class="d-flex align-items-center gap-2">
      <audio [src]="audioUrl()" controls class="w-100"></audio>
      <span
        class="align-items-center btn btn-danger btn-h45 d-flex justify-content-center p-0 rounded-circle wh-48"
        role="button"
      >
        <i class="bi bi-trash fs-16" role="button" (click)="clearRecording()"></i>
      </span>
    </div>
  </div>
</ng-template>
